import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class BulletPointsConverter extends CmsConverterService<BulletPointsData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_text ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? ''
    }
  }
}

export const BULLET_POINTS_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, BulletPointsData>>('BulletPointsConverterToken')

export interface BulletPointsData extends ConvertedComponentData {
  backgroundColor: string;
  headline: TextInput;
  text: TextInput;
}
